import LabelNone from '@/components/label_none';
import AddOrupEnroll from '@/page/enrollPlan/list/addOrupEnroll';
import { message } from 'antd';
import { LgButton, LgPopLayer, LgTable } from 'lancoo-web-ui';
import { useEffect, useRef, useState } from 'react';
import './index.scss'
import { useLocation } from 'react-router-dom';
import { Ico } from '@/components/Ico';
import ReportDrawer from './EnrollErrorDrawer';
import { CommmonGet, CommmonPost } from '@/util/network/api';
import { useSelector } from 'react-redux';
import { selectUserId } from '../../../../../store/reducers/userInfo';
import EnrollErrorModal from './EnrollErrorModal';
import ViewExamTicketModal from './TextCardDetail';

const columns: any = [
    {
        title: "流程名称",
        dataIndex: "auditProcessName",
        key: "auditProcessName",
        align: "center",
        render: (value, record) => {
            return <div title={value} style={{ color: "#999999" }}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "审核原因",
        dataIndex: "reason",
        key: "reason",
        align: "center",
        render: (value, record) => {
            return <div title={value} style={{}}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "审核结果",
        dataIndex: "auditStatus",
        key: "auditStatus",
        align: "center",
        render: (value, record) => {
            return <div title={value == 0 ? '未审核' : value == 1 ? '通过' : value == 2 ? '未通过' : '返回修改未审核'} style={{}}>
                {
                    value == 0 ? <span style={{color: "#ff6600"}}>未审核</span> :
                        value == 1 ? <span style={{ color: "#009900" }}>通过</span> :
                            value == 2 ? <span style={{ color: "#ff0000" }}>未通过</span> :
                                <span>返回修改未审核</span>
                }
            </div>
        },
    },
    {
        title: "审核时间",
        dataIndex: "auditTime",
        key: "auditTime",
        align: "center",
        width: 160,
        render: (value, record) => {
            return <div title={value} style={{ color: "#999999" }}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "审核人",
        align: "center",
        dataIndex: "auditUserName",
        key: "auditUserName",
        render: (value, record) => {
            return <div title={value} style={{ color: "#333333" }}>
                {value || "--"}
            </div>
        },
    },
];

const payColumns: any = [
    {
        title: "缴费信息项",
        dataIndex: "paymentItemName",
        key: "paymentItemName",
        align: "center",
        render: (value, record) => {
            return <div title={value} style={{ color: "#999999" }}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "缴费金额(元)",
        dataIndex: "paymentAmount",
        key: "paymentAmount",
        align: "center",
        render: (value, record) => {
            return <div title={value} style={{}}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "缴费状态",
        dataIndex: "paymentStatus",
        key: "paymentStatus",
        align: "center",
        render: (value, record) => {
            return <div title={value == 0 ? '未缴费' : value == 1 ? '已缴费' : value == 2 ? '已退费' : ''} style={{}}>
                {
                    value == 0 ? <span style={{color: "#ff6600"}}>未缴费</span> :
                        value == 1 ? <span style={{ color: "#009900" }}>已缴费</span> :
                            value == 2 ? <span style={{ color: "#ff6600" }}>已退费</span> :
                                ''
                }
            </div>
        },
    },
    {
        title: "缴费时间",
        dataIndex: "paymentTime",
        key: "paymentTime",
        align: "center",
        width: 160,
        render: (value, record) => {
            return <div title={value} style={{ color: "#999999" }}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "缴费方式",
        align: "center",
        dataIndex: "paymentType",
        key: "paymentType",
        render: (value, record) => {
            return <div title={value === 1? "线下缴费": value === 2? "微信支付": "--"} style={{ color: "#333333" }}>
                {value === 1? "线下缴费": value === 2? "微信支付" : "--"}
            </div>
        },
    },
    {
        title: "缴费备注",
        align: "center",
        dataIndex: "paymentRemark",
        key: "paymentRemark",
        render: (value, record) => {
            return <div title={value} style={{ color: "#333333" }}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "操作",
        align: "center",
        dataIndex: "operate",
        key: "operate",
        render: (value, record) => {
            return <div title={value} style={{ color: "#333333" }}>
                --
            </div>
        },
    },
];

const scoreColumns: any = [
    {
        title: "考试成绩状态",
        dataIndex: "examScoreStatus",
        key: "examScoreStatus",
        align: "center",
        render: (value, record) => {
            return <div title={value===1? "已发布": value === 2? "未发布":""} style={{ color: value===1? "#009900": value === 2? "#ff6600":"#999999" }}>
                {value===1? "已发布": value === 2? "未发布":""}
            </div>
        },
    },
    {
        title: "总分",
        dataIndex: "totalScore",
        key: "totalScore",
        align: "center",
        render: (value, record) => {
            return <div title={value} style={{}}>
                {value || "--"}
            </div>
        },
    },
    {
        title: "考试成绩",
        dataIndex: "examSubjectScoreList",
        key: "examSubjectScoreList",
        align: "center",
        render: (value, record) => {
            let str = "";
            Array.isArray(value) &&
            value.forEach((item, index)=>{
                str += `${item.examSubjectName}: ${item.score}`;
                if(index !== value.length-1){
                    str += ", "
                }
            })
            return <div title={str} style={{ color: "#333" }}>
                {str || "--"}
            </div>
        },
    },
];
function AuditDetail(props: any) {
    const { data, selectItem, setRefreshKey } = props;
    const userId = useSelector(selectUserId);
    const { pathname } = useLocation();

    const registerRef = useRef<any>(null);

    const [btnFlag, setBtnFlag] = useState<boolean>(false);
    // 选中信息
    const [visible, setVisible] = useState<boolean>(false);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const [errorCount, setErrorCount] = useState<any>(0);
    const [errorVisible, setErrorVisible] = useState(false);
    const [payInfo, setPayInfo] = useState<any>({});
    const [testInfo, setTestInfo] = useState<any>({});
    const [cardInfo, setCardInfo] = useState<any>({});
    const [cardVisible, setCardVisible] = useState(false);
    const [scoreInfo, setScoreInfo] = useState<any>({});
    const [planInfo, setPlanInfo] = useState<any>({});

    const getTestCardInfo = (data) => {
        CommmonGet('/examCard/info', {
            planId: selectItem.planId,
            userId
        }).then((res: any) => {
            if(res){
                setCardInfo(res?.data||{});
                setCardVisible(true);
            }
        })
    }
    const testColumns: any = [
        {
            title: "准考证状态",
            dataIndex: "examCardStatus",
            key: "examCardStatus",
            align: "center",
            render: (value, record) => {
                return <div title={value===1? "已发布": value === 2? "未发布":""} style={{ color: value===1? "#009900": value === 2? "#ff6600":"#999999" }}>
                    {value===1? "已发布": value === 2? "未发布":""}
                </div>
            },
        },
        {
            title: "准考证号",
            dataIndex: "examCardNumber",
            key: "examCardNumber",
            align: "center",
            render: (value, record) => {
                return <div title={value} style={{}}>
                    {value || "--"}
                </div>
            },
        },
        {
            title: "考场",
            dataIndex: "examRoom",
            key: "examRoom",
            align: "center",
            render: (value, record) => {
                return <div title={value} style={{}}>
                    {value || "--"}
                </div>
            },
        },
        {
            title: "座位号",
            dataIndex: "seatNumber",
            key: "seatNumber",
            align: "center",
            width: 160,
            render: (value, record) => {
                return <div title={value}>
                    {value || "--"}
                </div>
            },
        },
        {
            title: "考试时间",
            align: "center",
            dataIndex: "examSubjectTimeList",
            key: "examSubjectTimeList",
            render: (value, record) => {
                let str = "";
                Array.isArray(value) &&
                value.forEach(item=>{
                    str += `${item.examSubjectName}: ${item.examSubjectStartTime}~${item.examSubjectEndTime}`
                })
                return <div title={str} style={{ color: "#333" }}>
                    {str || "--"}
                </div>
            },
        },
        {
            title: "操作",
            align: "center",
            dataIndex: "operate",
            key: "operate",
            render: (value, record) => {
                return <div className='operate-btn' onClick={()=>getTestCardInfo(record)}>
                    查看准考证
                </div>
            },
        },
    ];

    const getErrorCount = () => {
        CommmonGet('/applyError/recordCount', {
            planId: selectItem.planId,
            userId
        }).then((res:any) => {
            setErrorCount(res.data);
        }).catch(error => {
            
        })
    }
    const getCustomInfo = () => {
        CommmonGet('/portal/homepage/planDetail', {
            planId: selectItem.planId,
            addPageView: true
        }).then((res:any) => {
            let data = res.data||{};
            setPlanInfo(data);
            setPayInfo(data?.paymentInfo||{});
            setTestInfo(data?.examCardInfo||{});
            setScoreInfo(data?.examScoreInfo||{});
        }).catch(error => {
            
        })
    }
    useEffect(() => {
        for (var i in data) {
            // if (data[i].auditStatus == 0 || data[i].auditStatus == 2) {//重要有未审核、审核不通过都显示修改报名信息按钮
            if (data[i].auditStatus == 2) {
                setBtnFlag(true);
            }
        }
        getErrorCount();
        getCustomInfo();
    }, [data]);

    return (
        <div className='detail_cls' style={{paddingBottom: 20}}>
            <div className='detail_title' style={{marginTop: 0}}>
                <div className='title_text'>审核流程</div>
                <div>
                    {/* <span className='enroll_error_text' onClick={()=>setErrorVisible(true)}>报名信息有误申报记录{errorCount? `(${errorCount})`:""}</span>
                    <LgButton
                        backgroundType='opacification'
                        gradient
                        type='success'
                        onClick={() => {
                            setDrawerVisible(true);
                        }}
                        style={{
                            backgroundImage: 'linear-gradient(90deg, #32b332, #3bcd3b), linear-gradient(#a1adb4, #a1adb4)'
                        }}
                    >
                        报名信息有误申报
                    </LgButton> */}
                    {btnFlag &&
                    <LgButton
                        backgroundType='opacification'
                        gradient
                        type='info'
                        onClick={() => {
                            setVisible(true);
                        }}
                    >
                        修改报名信息
                    </LgButton>}
                </div>
            </div>
            <LgTable
                columns={columns}
                data={data}
                scroll={{ y: 200 }}
                emptyText={<LabelNone tips="暂无审核信息" search={false} />}
            />
            {
                [2,3].includes(planInfo?.enrollBatchType)?
                <>
                <div className='detail_title'>
                    <div className='title_text'>缴费信息</div>
                </div>
                <LgTable
                    columns={payColumns}
                    data={[
                        {
                            paymentItemName: payInfo.paymentItemName,
                            paymentAmount: payInfo.paymentAmount,
                            paymentStatus: payInfo.paymentStatus,
                            paymentTime: payInfo.paymentTime,
                            paymentType: payInfo.paymentType,
                            paymentRemark: payInfo.paymentRemark,
                        }
                    ]}
                    scroll={{ y: 200 }}
                    emptyText={<LabelNone tips="暂无缴费信息" search={false} />}
                />
                <div className='detail_title'>
                    <div className='title_text'>准考证信息</div>
                </div>
                <LgTable
                    columns={testColumns}
                    data={[
                        {
                            examCardStatus: testInfo.examCardStatus,
                            examCardNumber: testInfo.examCardNumber,
                            examRoom: testInfo.examRoom,
                            seatNumber: testInfo.seatNumber,
                            examSubjectTimeList: testInfo.examSubjectTimeList
                        }
                    ]}
                    scroll={{ y: 200 }}
                    emptyText={<LabelNone tips="暂无准考证信息" search={false} />}
                />
                <div className='detail_title'>
                    <div className='title_text'>考试成绩信息</div>
                </div>
                <LgTable
                    columns={scoreColumns}
                    data={[
                        {
                            examScoreStatus: scoreInfo.examScoreStatus,
                            totalScore: scoreInfo.totalScore,
                            examSubjectScoreList: scoreInfo.examSubjectScoreList
                        }
                    ]}
                    scroll={{ y: 200 }}
                    emptyText={<LabelNone tips="暂无考试成绩信息" search={false} />}
                />
                </>:
                ""
            }
            
            <LgPopLayer
                title={'修改报名信息'}
                isOpen={visible}
                isCoverLayerClickClose={false}
                onShowLayer={(value: boolean, type: string) => {
                    if (type === "onConfirm") {
                        const addOrupEnroll = registerRef.current;
                        addOrupEnroll.postData().then(res => {
                            setVisible(false);

                            setRefreshKey && pathname === '/enrollPlan' ? setRefreshKey() : setRefreshKey(refreshKey => refreshKey + 1);
                        }).catch(err => {
                            message.destroy()
                            err?.msg && err?.type && message[err.type](err.msg);
                        })
                    } else {
                        setVisible(false);
                    }
                }}
                width={1160}
                height={656}
                needScroll
                // scrollViewPosition={'In'}
                className='enrollPlan_pop'
                confirmText='修改'
            >
                <>
                    {visible &&
                        <AddOrupEnroll
                            ref={registerRef}
                            selectItem={selectItem}
                        />
                    }
                </>
            </LgPopLayer>

            <ReportDrawer
                visible={drawerVisible}
                onClose={() => setDrawerVisible(false)}
                onSubmit={(value)=>{
                    CommmonPost('/applyError/apply', {
                        planId: selectItem.planId,
                        userId,
                        ...value
                    }).then((res:any) => {
                        message.success(`提交成功`);
                    }).catch(error => {
                        
                    })
                }}
            />

            <EnrollErrorModal selectItem={selectItem} count={errorCount} visible={errorVisible} changeVisible={(value)=>setErrorVisible(value)} />

            {/* 查看准考证 */}
            <ViewExamTicketModal
                visible={cardVisible}
                data={cardInfo}
                onCancel={() => setCardVisible(false)}
                onEdit={() =>{}}
                // onDownload={() => message.success('开始下载准考证')}
            />
        </div>
    )
}

export default AuditDetail
